import { useTranslation } from 'react-i18next'

import { Alert, Text } from '@vtex/shoreline'

import ToggleInput from '~/components/Toggle'

import { Card, CardHeading, CardTitle } from '../styles'

const ListAsDestinationRetailer = ({
  availableForNewCampaigns,
  onToggleAvailability,
  error
}: {
  availableForNewCampaigns: boolean
  onToggleAvailability: (
    next: boolean,
    handleLoading?: (value: boolean) => void
  ) => void
  error: boolean
}) => {
  const { t } = useTranslation()

  return (
    <Card>
      <CardHeading>
        <CardTitle>{t('rm:config.destinationRetail.list.title')}</CardTitle>
        <Text variant="body">
          {t('rm:config.destinationRetail.list.description')}
        </Text>
      </CardHeading>

      {error ? (
        <Alert variant="critical">
          {t('common:messages.errorOccurred.message')}
        </Alert>
      ) : (
        <ToggleInput
          key={String(availableForNewCampaigns)}
          name="available_for_new_campaigns"
          label={t('rm:config.destinationRetail.list.toggle.label')}
          description={t('rm:config.destinationRetail.list.toggle.footer')}
          isAsync
          isChecked={availableForNewCampaigns}
          size="small"
          onChange={({
            e,
            handleLoading
          }: {
            e: React.ChangeEvent<HTMLInputElement>
            handleLoading: (value: boolean) => void
          }) => onToggleAvailability(e.target.checked, handleLoading)}
          textLeft
        />
      )}
    </Card>
  )
}

export default ListAsDestinationRetailer
